
    <div class="w-100 h-100 d-flex p-2 flex-column">
      <textarea
        rows="10"
        cols="60"
        class="form-control font-size-11 fieldmagic-data-grid-textarea-input"
        [(ngModel)]="value"
        [attr.maxLength]="max"
        [matTooltip]="tooltip$ | async"
        [attr.placeholder]="placeholder$ | async"
        (ngModelChange)="onChanged()"
        (keydown)="onKeyDown($event)"
        autofocus
      >
      </textarea>

      <div
        *ngIf="max | filled"
        class="d-flex w-100 justify-content-end"
      >
        <small class="text-help">
          {{ '%d/%d' | sprintf: [remaining$ | async, max]}}
        </small>
      </div>
    </div>
  